import { compose } from 'ramda'
import { withHandlers, withState } from 'recompose'

const handleMeasure = ({ setContainerWidth }) =>
  ({ imageSize: { width } }) => setContainerWidth(width)

export default () => compose(
  withState('containerWidth', 'setContainerWidth'),
  withHandlers({ handleMeasure }),
)



// WEBPACK FOOTER //
// ./client/modules/util/withMeasure.js